import scrollToAnchor from "./_scroll-to";

const tableOfContents = document.querySelector('#table-of-contents');

if(tableOfContents) {
  let levels = tableOfContents.getAttribute('data-levels') ?? 'all';
  let contentSection = document.querySelector('#content-section');
  if(document.querySelector('.article-body')) {
    contentSection = document.querySelector('.article-body');
  }

  function generateTableOfContents() {
    // Find container element or create one if it doesn't exist
    let tocContainer = document.getElementById('toc');
    if (!tocContainer) {
      tocContainer = document.createElement('div');
      tocContainer.id = 'toc';
      document.body.insertBefore(tocContainer, document.body.firstChild);
    }  
    
    // Get all direct children of content section
    const contentChildren = Array.from(contentSection.children);
    
    // Filter to only include heading elements
    const headings = contentChildren.filter(element => 
      /^H[2-6]$/.test(element.tagName)
    );
    
    if (headings.length === 0) {
      tocContainer.textContent = 'Ingen direkte overskrifter funnet i innholdet.';
      return;
    }
    
    // Create the main TOC list
    const tocList = document.createElement('ul');
    tocList.className = 'toc-list';
    tocContainer.appendChild(tocList);
    
    // Track the lists at each level
    const lists = {
      0: tocList // Base list
    };
    
    // Find the minimum heading level to use as the base level
    const headingLevels = headings.map(h => parseInt(h.tagName.charAt(1)));
    const minLevel = Math.min(...headingLevels);
    
    // Process each heading to create a nested structure
    headings.forEach((heading) => {
      // Create an ID for the heading if it doesn't have one
      if (!heading.id) {
        heading.id = heading.textContent.replace(/[^\p{L}\d]+/gu, '-')
          .replace(/æ/g, 'ae')
          .replace(/ø/g, 'o')
          .replace(/å/g, 'a')
          .replace(/[^\w\s-]/g, '') // Remove special characters
          .trim()
          .replace(/<br>/g, '')
          .replace(/-+/g, '-')
          .toLowerCase();
      }

      // Get heading level (1 for h1, 2 for h2, etc.)
      const level = parseInt(heading.tagName.charAt(1));

      if(levels == 'all' || (level - 1) <= levels) {
        // Create list item with anchor
        const item = document.createElement('li');
        item.className = 'level-' + (level - 1);
        const link = document.createElement('a');
        if(level === 2) {
          link.className = 'styled-link';
        }
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.appendChild(link);
        
        // Normalize the level relative to the minimum level found
        const normalizedLevel = level - minLevel;
        
        // Reset lists for levels deeper than the current one
        // This prevents incorrect nesting when we go from a deeper level back to a higher level
        for (let i = normalizedLevel + 1; lists[i]; i++) {
          delete lists[i];
        }
        
        // Make sure we have all parent lists
        for (let i = 0; i <= normalizedLevel; i++) {
          if (!lists[i]) {
            // Create a new list level if it doesn't exist
            const newList = document.createElement('ul');
            // Find the closest parent level that exists
            let parentLevel = i - 1;
            
            // If we found a parent, add this list as the last child of the last item
            if (parentLevel >= 0 && lists[parentLevel] && lists[parentLevel].lastElementChild) {
              lists[parentLevel].lastElementChild.appendChild(newList);
              lists[i] = newList;
              lists[parentLevel].lastElementChild.className += ' has-children';
            } else {
              // Otherwise, just add it to the main list
              lists[0].appendChild(newList);
              lists[i] = newList;
            }
          }
        }
        
        // Add the item to the appropriate list
        lists[normalizedLevel].appendChild(item);
      }
    });
 

    $('a').click(function(e) {
      scrollToAnchor(this.href, e, 80);
    });
    
  }

  const accordionBtn = tableOfContents.querySelector('.accordion-btn');
    accordionBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      let parent = accordionBtn.parentNode;
      if(!parent.classList.contains('open')) {
          parent.classList.add('open');
          accordionBtn.setAttribute('aria-expanded', 'true');
      }
      else {
          parent.classList.remove('open');
          accordionBtn.setAttribute('aria-expanded', 'false');
      }
  });

  generateTableOfContents();
}